<template>
  <div class="container">
    <!--预览-->
    <app-header title="产品规格书"/>
    <div>
      <pdf
        :src="pdfSrc"
        :page="currentPage"
        @num-pages="pageCount=$event"
        @page-loaded="currentPage=$event"
        @loaded="loadPdfHandler" >
      </pdf>
    </div>
    <!--页码-->
    <div class="pdf" v-show="fileType === 'pdf'">
      <div class="pagesize">
        <!--上一页-->
        <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
        {{currentPage}} / {{pageCount}}
        <!--下一页-->
        <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</span>
      </div>
    </div>
  </div>
</template>
<script>
  import pdf from 'vue-pdf'  // 引入pdf组件
  export default {
    metaInfo: {
      title: 'This is the test',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
      ]
    },
    components: {pdf},  // 引入pdf组件
    data () {
      return {
        currentPage: 0,       // pdf文件页码
        pageCount: 0,         // pdf文件总页数
        fileType: 'pdf',      // 文件类型
        pdfSrc:'',
        //pdfSrc: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf' // pdf文
      }
    },
    created() {
      this.pdfSrc = pdf.createLoadingTask(this.$route.query.pdf,{withCredentials: false})
    },
    methods: {
      // 返回上级
      goBack(){
        this.$router.back();
      },
      // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
      changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },
      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
      }
    }
  }
</script>
<style lang="scss" scoped>
  .container{
    padding-top: 50px;
  }
  .pdf-box {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    max-width: 1024px;
    width: 100%;
    margin: 0 auto;
    overflow-x: hidden;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    font-size: .28rem;
    span {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/detail/pdf.vue